import React from "react"

import { ChildSelector } from "../helpers/ChildSelector"

import Video from "./_base/Video"

import WPCta from "./_base/WPCta"

import * as videoSectionStyles from "../styles/VideoSection.module.css"

export default function VideoSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `video-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const text = ChildSelector.select(
    content,
    `video-section-info`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const searchieVideo = ChildSelector.select(
    content,
    `searchie-video`,
    ChildSelector.SELECTOR_TYPE.SEARCHIE_VIDEO,
  )
  const youtubeVideos = ChildSelector.select(
    content,
    `youtube-video`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  return (
    <div className={`row ${props.className} ${videoSectionStyles.wrapper}`}>
      <div className={`col-12 ${videoSectionStyles.title}`}>
       {title && <h2>{title}</h2>}
      </div>
      {searchieVideo && (
        <div className={`row ${videoSectionStyles.videoWrapper}`}>
          <div className={`col-12 ${videoSectionStyles.video}`}>
            <Video videoSrcURL={searchieVideo} />
          </div>
        </div>
      )}
      {youtubeVideos && Array.isArray(youtubeVideos) && (
        <div className={`row ${videoSectionStyles.videoWrapper}`}>
          {youtubeVideos.map((v, i) => (
            <div
              key={i}
              className={`col-12 ${videoSectionStyles.video}`}
              dangerouslySetInnerHTML={{ __html: v }}
            />
          ))}
        </div>
      )}
      <div className={`col-12 ${videoSectionStyles.infoCta}`}>
        <p>{text}</p>
        <WPCta
          holder={content}
          selector={`video-connect`}
          translate={true}
          className={`${videoSectionStyles.ctaBtn}`}
          pageContext={props.pageContext}
        />
      </div>
    </div>
  )
}
